<template>
  <div class="invite">
    <HeaderReturn title="邀请好友"></HeaderReturn>
   
    <div class="invite_code">
      <div class="invite_title">
        <p>扫描二维码下载了解最新资讯</p>
      </div>
      <!-- <br/> -->
      <div class="code_main">
        <!-- 二维码 -->

        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <div class="fn-15 codeInfo">
          <vue-qr :text="inviteCode" :size="120" />
        </div>
      </div>
    </div>
    <van-divider
      :style="{
        color: `#999`,
        fontSize: `14px`,
        borderColor: 'rgb(26,166,191)',
        padding: '0 16px',
      }"
    >
      or
    </van-divider>
    <div class="copy_box">
      <div>
        <p>您的邀请码</p>
      </div>
      <div>{{ inviteCode }}</div>
      <div>
        复制
        <!-- <van-icon
            name="description"
            color="rgba(1, 42, 255, 1)"
            size="18"
            v-clipboard:copy="inviteCode"
            v-clipboard:success="onCopy"
          /> -->
          <i class="el-icon-copy-document" v-clipboard:copy="inviteCode"
            v-clipboard:success="onCopy"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon, Divider } from "vant";
Vue.use(NoticeBar).use(Icon).use(Divider);
import vueQr from "vue-qr";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      UrlYqhy: "",
      inviteCode: "",
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.inviteCode = JSON.parse(
      sessionStorage.getItem("ms_user")
    ).user.inviteCode;
    this.UrlYqhy =
      window.location.origin +
      "/#/member/register?promotion=" +
      JSON.parse(sessionStorage.getItem("ms_user")).user.inviteCode;
  },
  methods: {
    onCopy() {
      this.$toast('复制成功');
    },
    goLink(path) {
      if (path) {
        this.$router.push({
          path,
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .copy_box {
  margin-top: 75px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  div:nth-child(1) {
    p {
      color: #999;
      font-size: 14px;
    }
  }
  div:nth-child(2) {
    margin: 10px;
    padding: 10px;
    // background-color: rgb(12, 42, 52);
    border-radius: 4px;
    border: solid 1px #f89b19;
  }
  div:nth-child(3) {
    // margin: 10px;
    // padding: 10px;
    // background-color: rgb(12,42,52);
    // border-radius: 4px;
    // border: solid 1px rgb(19,109,140);
    color: var(--unnamed, #f89b19);
    font-size: 14px;
  }
}
::v-deep .codeInfo {
  background-color: #f89b19;
  border: 10px solid #f89b19;
  border-radius: 10px;
}
::v-deep .invite_code {
  margin: 88px 0;
  //   border: solid 1px red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .invite_title {
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC;
    margin-bottom: 20px;
  }
  .code_main {
    width: 217px;
    height: 217px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: solid 1px red;
    // border-radius: 10px;
    position: relative;
    span {
      position: absolute;
      width: 50px;
      height: 50px;
      // border: solid 1px red;
    }
    span:nth-child(1) {
      top: 0;
      left: 0;
      // background-color: #fff;
      border-top: 1px solid #f89b19;
      border-left: 1px solid #f89b19;
      border-radius: 10px 0 0 0;
    }
    span:nth-child(2) {
      top: 0;
      right: 0;
      border-top: 1px solid #f89b19;
      border-right: 1px solid #f89b19;
      border-radius: 0 10px 0 0;
    }
    span:nth-child(3) {
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #f89b19;
      border-left: 1px solid #f89b19;
      border-radius: 0 0 0 10px;
    }
    span:nth-child(4) {
      bottom: 0;
      right: 0;
      border-bottom: 1px solid #f89b19;
      border-right: 1px solid #f89b19;
      border-radius: 0 0 10px 0;
    }
  }
}
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.invite {
  margin: 50px 10px;
  padding-bottom: 30px;

  ::v-deep .van-nav-bar__title {
    color: #fff;
  }

}
</style>
